import { getMinutesFromDateTime } from 'framework/utils';
import { FocusTimeAction, FocusTimeActionType, FocusTimeState } from './types';

export const initialFocusTimeState: FocusTimeState = {
  slots: [],
  currentMinutes: getMinutesFromDateTime(),
};

export const focusTimeReducer = (state: FocusTimeState, action: FocusTimeAction): FocusTimeState => {
  switch (action.type) {
    case FocusTimeActionType.SetSlots:
      return {
        ...state,
        slots: action.payload,
      };
    case FocusTimeActionType.SetCurrentMinutes:
      return {
        ...state,
        currentMinutes: action.payload,
      };
    default:
      return state;
  }
};
